import { api } from "../../app/http/axiosClient.js";

export async function createEvent(values) {
    const payload = {
        title: values.title.trim(),
        description: values.description.trim(),
        attendees_age_range:
            values.minAge !== null &&
                values.minAge !== undefined &&
                values.minAge !== ""
                ? String(values.minAge)
                : null,
        venue: values.venue.trim(),
        start_date: values.startDate,
        start_time: values.startTime,
        end_date: values.endDate || null,
        end_time: values.endTime || null,
        slug: values.slug.trim(),
    };

    const response = await api.post("dashboard/events", payload);
    return response.data;
}

export async function uploadPoster(eventId, file) {
    if (!(file instanceof File) || file.size === 0) {
        throw new Error("A valid poster image is required.");
    }

    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post(
        `dashboard/events/${eventId}/poster-image`,
        formData
    );

    return response.data;
}

export async function updateEvent(eventId, values) {
    const payload = {
        title: values.title.trim(),
        description: values.description.trim(),
        attendees_age_range:
            values.minAge !== null &&
                values.minAge !== undefined &&
                values.minAge !== ""
                ? String(values.minAge)
                : null,
        venue: values.venue.trim(),
        start_date: values.startDate,
        start_time: values.startTime,
        end_date: values.endDate || null,
        end_time: values.endTime || null,
    };

    const response = await api.put(
        `dashboard/events/${eventId}`,
        payload
    );

    return response.data;
}

/*function combineDateAndTime(date, time) {
    if (!date || !time) {
        return null;
    }
    const combined = new Date(`${date}T${time}`);
    if (Number.isNaN(combined.getTime())) {
        throw new Error("Invalid sale date or time.");
    }
    return combined.toISOString();
}*/

export async function publishEvent(eventId) {
    await api.patch(
        `/dashboard/events/${eventId}/status`,
        {
            status: "pending_approval",
        }
    );
}

export async function deleteEvent(eventId) {
    await api.delete(
        `/dashboard/events/${eventId}`
    );
}

export async function createTicketType(eventId, values) {
    const response = await api.post(
        `dashboard/events/${eventId}/ticket-types`,
        buildTicketTypePayload(values)
    );
    return response.data;
}

export async function updateTicketType(eventId, ticketTypeId, values) {
    const response = await api.put(
        `dashboard/events/${eventId}/ticket-types/${ticketTypeId}`,
        buildTicketTypePayload(values)
    );
    return response.data;
}

export async function deleteTicketType(eventId, ticketTypeId) {
    const response = await api.delete(
        `dashboard/events/${eventId}/ticket-types/${ticketTypeId}`,
    );
    return response.data;
}

export async function toggleTicketTypeHiding(eventId, ticketTypeId) {
    const response = await api.patch(
        `dashboard/events/${eventId}/ticket-types/${ticketTypeId}/toggle-hide`,
    );
    return response.data;
}

export async function toggleTicketTypeForceSoldOut(eventId, ticketTypeId) {
    const response = await api.patch(
        `dashboard/events/${eventId}/ticket-types/${ticketTypeId}/toggle-forced-sold-out`,
    );
    return response.data;
}

function toNullableInteger(value) {
    if (value === "" || value == null) {
        return null;
    }

    return parseInt(value, 10);
}

function buildTicketTypePayload(values) {
    const payload = {
        name: values.name.trim(),
        price: Number(values.price),
        description: values.description?.trim() || null,
        inventory_cap: toNullableInteger(values.inventoryCap),
        max_buy_at_a_time:
            values.maxBuyAtATime === "" || values.maxBuyAtATime == null
                ? 10
                : Math.max(1, Number.parseInt(values.maxBuyAtATime, 10)),
        sales_start_at_date: values.startDate || null,
        sales_start_at_time: values.startTime || null,
        sales_end_at_date: values.endDate || null,
        sales_end_at_time: values.endTime || null,
    };
    return payload;
}
export function getLocalDate(value) {
    if (!value) {
        return "";
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return "";
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

export function getLocalTime(value) {
    if (!value) {
        return "";
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return "";
    }
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
}